import { FlexView } from '@cuemath/comps';
import styled from 'styled-components';

export const StudentTransferWrapper = styled(FlexView)`
  padding: ${({ padding }) => padding || '17px 16px 40px'};
`;
